<template>
  <a
    :href="link"
    class="card"
  >
    <ui-image
      v-region-in-country-click-tracker="getRegionInCountryClickEventParams"
      :photo="region.image"
      :alt="region.name_ru"
      class="card__img"
      fit="cover"
      fetchpriority="high"
      loading="eager"
    />
    <div
      v-region-in-country-click-tracker="getRegionInCountryClickEventParams"
      class="card__info"
    >
      {{ region.name_ru }}
    </div>
  </a>
</template>
<script setup lang="ts">
  import { UiImage } from '@experience/core-image-ui';
  import type { MappedRegionsInCountryInfo } from '@/entities/regionsInCountry/types/regionsInCountry';
  import { useClickTracker } from '@/entities/sogu';
  import { withMfsDomain } from '@/shared/lib/withMfsDomain';

  interface Props {
    region: MappedRegionsInCountryInfo;
  }

  const props = defineProps<Props>();

  const link = computed(() => {
    const country = props.region?.url?.params?.country;
    const regionSlug = props.region?.url?.params?.regionSlug;
    const url = `/tours/${country}/${regionSlug}/`;

    return withMfsDomain(url);
  });
  const getRegionInCountryClickEventParams = () => ({
    id: props.region.id,
    name: props.region.name_ru,
  });
  const vRegionInCountryClickTracker = useClickTracker('destinations-country:regions:region.click');
</script>

<style lang="scss" scoped>
  .card {
    display: grid;
    gap: 4px 0;
    align-content: start;
    text-decoration: none;
  }

  .card__img {
    display: block;
    object-fit: cover;
    width: 100%;
    border-radius: 8px;
    aspect-ratio: 5/4;
  }

  .card__info {
    padding-right: 12px;
    color: var(--alias-color-text-default);
    font-size: 14px;
    line-height: 20px;
  }
</style>
